import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DesignSubmittalsPage } from '@/features/design/submittals-page';

const searchSchema = z.object({ submittal: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/projects/$projectId/design/submittals')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <DesignSubmittalsPage projectId={projectId} submittalId={search.submittal} />;
}
